<template>
  <div class="page-common-container" v-loading="loading">
    <div class="page-common-container-left">
      <pageForm ref="pageForm" :title="$i18n.$t('地点筛选')" :btnName="$i18n.$t('查询')" :fields="fields" @search="search" />
    </div>
    <div class="page-common-container-right">
      <div class="page-common-container-right-content" :class="{ hasName: addressName }" style="position: relative;">
        <!-- <chinaMap ref="chinaMap" :list="placeList" /> -->
        <div style="width: 100%;height: 100%;position: absolute;left: 0;top: 0;z-index: 1000;background-color: #FAF8F5;">
          <VisIndex :data="relationData" @tab-change="tabChange" />
          <div class="page-common-container-right-content-no-data" v-if="relationData && relationData.data.length === 0 && relationData.link.length === 0">
            <img src="@/assets/map/no-data.png" alt="">
            <p>{{ $i18n.$t('没有查询到相关的地点') }}</p>
          </div>
        </div>
      </div>
      <div class="page-common-container-right-list" :class="{ hasName: addressName }">
        <div class="page-common-container-right-list-title">
          <div class="page-common-container-right-list-title-top">
            <div class="page-common-container-right-list-title-top-name">{{ $i18n.$t('查询结果') }}</div>
            <el-button type="primary" @click.stop="exportData" :disabled="!relationData.data.length || downloadLoading" :loading="downloadLoading">{{ $i18n.$t('导出数据') }}</el-button>
          </div>
          <div class="page-common-container-right-list-title-bottom">
            {{ $i18n.$t('本次图谱共查询到') }}{{ personTotal }}{{ $i18n.$t('地点关联有') }}{{ linkTotal }}{{ $i18n.$t('个人物节点。全部数据请点击“导出数据”按钮导出。') }}
          </div>
        </div>
        <div class="page-common-container-right-list-content">
          <!-- <div class="page-common-container-right-list-content-title">以下为按照人物足迹数量排序前十位的人物以及按照地点热度排序前十位的地点：</div> -->
          <div class="page-common-container-right-list-content-item" v-for="(per, index) in addressList" :key="index">
            <div class="page-common-container-right-list-content-item-title">
              <div class="page-common-container-right-list-content-item-title-name">{{ per.Name }}</div>
              <div class="page-common-container-right-list-content-item-title-count">{{ $i18n.$t('关系数据：') }}{{ per.relation_count }}{{ $i18n.$t('条') }}</div>
            </div>
            <div class="page-common-container-right-list-content-item-table">
              <div class="page-common-container-right-list-content-item-table-head">
                <div class="page-common-container-right-list-content-item-table-head-th">{{ $i18n.$t('人物名称') }}</div>
                <div class="page-common-container-right-list-content-item-table-head-th">{{ $i18n.$t('记载出处') }}</div>
              </div>
              <template v-for="(link, j) in per.link_node">
                <div class="page-common-container-right-list-content-item-table-row" :key="j" v-if="per.showMore || (!per.showMore && j < 4)">
                  <div class="page-common-container-right-list-content-item-table-row-td">{{ link.Name }}</div>
                  <div class="page-common-container-right-list-content-item-table-row-td" :title="link.RecordedIn">{{ link.RecordedIn }}</div>
                </div>
              </template>
            </div>
            <div class="page-common-container-right-list-content-item-more" v-if="per.link_node.length > 4" @click.stop="per.showMore = !per.showMore">
              <template v-if="per.showMore">
                {{ $i18n.$t('收起') }}
                <i class="el-icon-arrow-up"></i>
              </template>
              <template v-else>
                {{ $i18n.$t('查看更多') }}
                <i class="el-icon-arrow-down"></i>
              </template>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { allPlace, addressRelation } from '@/api/place'
import { i18n } from '@/i18n'
export default {
  name: 'placeIndex',
  meta: {
    title: i18n.$t('地点查询')
  },
  data () {
    return {
      fields: [
        {
          type: 'address',
          label: i18n.$t('地点'),
          placeholder: i18n.$t('请输入地点名称'),
          key: 'Name'
        // },
        // {
        //   type: 'selectGroup',
        //   label: '时间',
        //   separator: '至',
        //   start: {
        //     placeholder: '全部',
        //     key: 'Dynasty_start',
        //     options: this.$store.state.dict.allDynasty || [],
        //     defaultValue: '全部'
        //   },
        //   end: {
        //     placeholder: '全部',
        //     key: 'Dynasty_end',
        //     options: this.$store.state.dict.allDynasty || [],
        //     defaultValue: '全部'
        //   }
        }
        // {
        //   type: 'select',
        //   label: i18n.$t('人物设置'),
        //   placeholder: i18n.$t('请选择'),
        //   key: 'is_extension',
        //   clearable: true,
        //   options: [
        //     { label: i18n.$t('显示所有人物'), value: '1' },
        //     { label: i18n.$t('仅显示传记人物'), value: '0' }
        //   ],
        //   defaultValue: '1'
        // }
      ],
      placeList: [],
      relationData: {
        data: [],
        link: []
      },
      showMap: true,
      loading: false,
      personTotal: 0,
      linkTotal: 0,
      addressList: [],
      addressName: '',
      downloadLoading: false,
      queryParams: {}
    }
  },
  methods: {
    tabChange (Id) {
      this.getAddressRelation({
        ...this.queryParams,
        Id: Id
      })
    },
    exportData () {
      const form = this.$refs.pageForm.form || {}
      this.downloadLoading = true
      addressRelation({
        ...form,
        output: 1
      }, {
        responseType: 'blob'
      }).then(res => {
        const a = document.createElement('a')
        a.href = URL.createObjectURL(res)
        a.download = i18n.$t('地点查询.xlsx')
        a.click()
        URL.revokeObjectURL(a.href)
      }).finally(() => {
        this.downloadLoading = false
      })
    },
    search (params) {
      this.addressName = params.Name
      this.getAddressRelation(params)
      // if (params.Name) {
      // } else {
      //   this.getAllPlace()
      // }
    },
    getAllPlace () {
      this.loading = true
      allPlace().then(res => {
        this.placeList = res.data
      }).finally(() => {
        this.showMap = true
        this.loading = false
      })
    },
    getAddressRelation (params) {
      this.loading = true
      this.queryParams = params
      addressRelation(params).then(res => {
        if (res.data.address && res.data.address.length > 0) {
          // this.showMap = false
          // this.$refs.chinaMap.close()
          this.relationData = {
            data: [
              ...res.data.data,
              ...res.data.address
            ],
            link: res.data.link
          }
          this.$set(this.relationData, 'searchKey', params.Name)
          this.personTotal = res.data.address.length
          this.linkTotal = res.data.link.length
          this.addressList = res.data.sidebar.map(item => {
            return {
              ...item,
              showMore: false
            }
          })
        } else {
          // this.showMap = true
          this.personTotal = 0
          this.linkTotal = 0
          this.addressList = []
        }
      // }).catch(() => {
      //   this.showMap = true
      }).finally(() => {
        this.loading = false
      })
    }
  }
}
</script>
